import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { DefaultLayout } from '../../layout/theme-customizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import tema from "../../services/Plantilla";
import validator from 'validator';

// Modal de Crear Usuario
class ModalCrear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo_identificacion: '',
            identificacion: '',
            nombre: '',
            nombre_2: '',
            apellido: '',
            apellido_2: '',
            sexo: '',
            estado: '',
            cargo: '',
            password1: '',
            password2: '',
            correo_electronico: '',
            rol: '',
            roles: [],
            cliente: [],
            clienteSeleccionado: '',
            errores: {},
            touched: {}, // Para saber qué campos han sido tocados
            rol_actual: localStorage.getItem('rol')
        }
    }

    cambioValor = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touched: {
                ...this.state.touched,
                [name]: true
            }
        }, () => {
            // Validar el campo después de actualizar
            this.validarCampo(name, value);
        });
    }

    // Validar campo individual
    validarCampo = (nombreCampo, valor) => {
        const errores = { ...this.state.errores };
        
        switch(nombreCampo) {
            case 'tipo_identificacion':
                if (!valor) errores.tipo_identificacion = 'Seleccione el Tipo de Documento';
                else delete errores.tipo_identificacion;
                break;
            case 'identificacion':
                if (!valor.trim()) errores.identificacion = 'Digite la Identificación';
                else if (!validator.isNumeric(valor) && valor.trim().length < 5) 
                    errores.identificacion = 'La identificación debe ser numérica y tener al menos 5 dígitos';
                else delete errores.identificacion;
                break;
            case 'nombre':
                if (!valor.trim()) errores.nombre = 'Digite el Nombre';
                else if (!validator.isAlpha(valor.replace(/\s/g, ''), 'es-ES')) 
                    errores.nombre = 'El nombre solo debe contener letras';
                else delete errores.nombre;
                break;
            case 'apellido':
                if (!valor.trim()) errores.apellido = 'Digite el Apellido';
                else if (!validator.isAlpha(valor.replace(/\s/g, ''), 'es-ES')) 
                    errores.apellido = 'El apellido solo debe contener letras';
                else delete errores.apellido;
                break;
            case 'sexo':
                if (!valor) errores.sexo = 'Seleccione el Género';
                else delete errores.sexo;
                break;
            case 'estado':
                if (valor === '') errores.estado = 'Seleccione el Estado';
                else delete errores.estado;
                break;
            case 'cargo':
                if (!valor.trim()) errores.cargo = 'Digite el Cargo';
                else delete errores.cargo;
                break;
            case 'password1':
                if (!valor) errores.password1 = 'Digite la Contraseña';
                else {
                    const validacionPass = this.validarPassword(valor);
                    if (validacionPass !== 0) {
                        errores.password1 = 'La contraseña debe contener mínimo 8 caracteres, 1 letra minúscula, 1 mayúscula, 1 número y 1 carácter especial';
                    } else {
                        delete errores.password1;
                    }
                }
                // Validar también password2 si ya tiene valor
                if (this.state.password2) {
                    this.validarCampo('password2', this.state.password2);
                }
                break;
            case 'password2':
                if (!valor) errores.password2 = 'Confirme la Contraseña';
                else if (valor !== this.state.password1) 
                    errores.password2 = 'Las contraseñas no coinciden';
                else delete errores.password2;
                break;
            case 'correo_electronico':
                if (!valor.trim()) errores.correo_electronico = 'Digite el Correo Electrónico';
                else if (!validator.isEmail(valor)) 
                    errores.correo_electronico = 'Digite un email válido';
                else delete errores.correo_electronico;
                break;
            case 'rol':
                if (!valor) errores.rol = 'Seleccione el Rol';
                else delete errores.rol;
                break;
            default:
                break;
        }
        
        this.setState({ errores });
    }

    validarPassword(pass) {
        if (validator.isStrongPassword(pass, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
        })) {
            return 0;
        } else {
            return 1;
        }
    }

    // Validar todos los campos antes de enviar
    validarTodosLosCampos = () => {
        const campos = [
            'tipo_identificacion', 'identificacion', 'nombre', 'apellido', 
            'sexo', 'estado', 'cargo', 'password1', 'password2', 
            'correo_electronico', 'rol'
        ];
        
        // Marcar todos como tocados
        const touched = {};
        campos.forEach(campo => {
            touched[campo] = true;
        });
        
        // Validar cada campo
        campos.forEach(campo => {
            this.validarCampo(campo, this.state[campo]);
        });
        
        this.setState({ touched });
        
        // Verificar si hay errores
        return Object.keys(this.state.errores).length === 0;
    }

    enviarDatos = async (e) => {
    e.preventDefault();
    
    // Validar todos los campos
    if (!this.validarTodosLosCampos()) {
        Swal.fire({
            icon: 'error',
            title: 'Error de validación',
            text: 'Por favor, complete correctamente todos los campos obligatorios',
            timer: 3000
        });
        return;
    }

    const { usuario } = this.state;

    let formData = new FormData();
   /*  Object.keys(usuario).forEach(key => {
        if (key !== 'password1' && key !== 'password2') {
            let valor = usuario[key];
            
            // Verificar si el valor existe antes de hacer trim
            if (valor !== null && valor !== undefined) {
                // Aplicar trim solo a campos de texto que lo necesiten
                if (key === 'nombre' || key === 'nombre_2' || key === 'apellido' || key === 'apellido_2' || key === 'cargo') {
                    valor = valor.toString().trim();
                }
            } else {
                valor = ''; // Si es null o undefined, convertir a string vacío
            }
            
            formData.append(key, valor);
        }
    }); */
    
    if (usuario.password1 && usuario.password1 !== '') {
        formData.append('password1', usuario.password1);
        formData.append('password2', usuario.password2);
    }

    try {
        const datosRespuesta = await authAxios.post("usuario/editar", formData);
        await Swal.fire({
            icon: 'success',
            title: 'Usuario!',
            text: datosRespuesta.data.msj,
            timer: 2000
        });
        this.props.onClose();
        this.props.onUserUpdated();
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: error.response?.data?.msj || 'Ocurrió un error al actualizar el usuario'
        });
    }
}

    componentDidMount() {
        authAxios.get("usuario/roles")
            .then((datosRespuesta) => {
                this.setState({ 
                    roles: datosRespuesta.data.data,
                    cliente: datosRespuesta.data.clientes || []
                });
            })
            .catch(error => {
                console.error("Error cargando roles:", error);
            });
    }

    // Función para filtrar roles según el rol_actual
    filtrarRolesPorRol = (roles) => {
        const { rol_actual } = this.state;
        
        // Convertir a número para comparación segura
        const rolActualNum = parseInt(rol_actual);
        
        // Si rol_actual es igual a 1, mostrar todos los roles
        if (rolActualNum === 1) {
            return roles;
        }
        
        // Si rol_actual es diferente de 1, filtrar para NO mostrar el rol con id === 1
        return roles.filter(rol => rol.id !== 1);
    }

    // Verificar si un campo tiene error y ha sido tocado
    tieneError = (campo) => {
        return this.state.touched[campo] && this.state.errores[campo];
    }

    render() {
        const { show, onClose } = this.props;
        const { nombre, nombre_2, apellido, apellido_2, sexo, identificacion, cargo, password1, password2, correo_electronico, roles, estado, tipo_identificacion, rol, errores, touched } = this.state;

        // Aplicar el filtro de roles según el rol_actual
        const rolesFiltrados = this.filtrarRolesPorRol(roles);

        if (!show) return null;

        return (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">REGISTRO DE USUARIOS</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={this.enviarDatos} noValidate>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className='row g-3'>
                                            <div className="col-md-3">
                                                <label htmlFor="tipo_identificacion">T. Identificación *</label>
                                                <select name="tipo_identificacion"
                                                    id="tipo_identificacion"
                                                    className={`form-select form-select-sm ${this.tieneError("tipo_identificacion") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    value={tipo_identificacion}>
                                                    <option value="">Seleccione el Tipo de Documento</option>
                                                    <option value="CC">C.C.</option>
                                                    <option value="CE">C.E.</option>
                                                    <option value="NIT">NIT</option>
                                                    <option value="TI">TI</option>
                                                </select>
                                                {this.tieneError("tipo_identificacion") && 
                                                    <small className="invalid-feedback">{errores.tipo_identificacion}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="identificacion">Identificación *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("identificacion") ? "is-invalid" : ""}`} 
                                                       maxLength={20} 
                                                       type="text" 
                                                       name="identificacion" 
                                                       id="identificacion" 
                                                       value={identificacion} 
                                                       placeholder="Número" 
                                                       onChange={this.cambioValor} />
                                                {this.tieneError("identificacion") && 
                                                    <small className="invalid-feedback">{errores.identificacion}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="nombre">Nombre *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("nombre") ? "is-invalid" : ""}`} 
                                                       type="text" 
                                                       name="nombre" 
                                                       id="nombre" 
                                                       value={nombre} 
                                                       placeholder="Escriba el nombre" 
                                                       onChange={this.cambioValor} />
                                                {this.tieneError("nombre") && 
                                                    <small className="invalid-feedback">{errores.nombre}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="nombre_2">Segundo Nombre</label>
                                                <input className="form-control form-control-sm" 
                                                       type="text" 
                                                       name="nombre_2" 
                                                       id="nombre_2" 
                                                       value={nombre_2} 
                                                       placeholder="Escriba el segundo nombre" 
                                                       onChange={this.cambioValor} />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="apellido">Apellido *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("apellido") ? "is-invalid" : ""}`} 
                                                       type="text" 
                                                       name="apellido" 
                                                       id="apellido" 
                                                       value={apellido} 
                                                       placeholder="Escriba el apellido" 
                                                       onChange={this.cambioValor} />
                                                {this.tieneError("apellido") && 
                                                    <small className="invalid-feedback">{errores.apellido}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="apellido_2">Segundo Apellido</label>
                                                <input className="form-control form-control-sm" 
                                                       type="text" 
                                                       name="apellido_2" 
                                                       id="apellido_2" 
                                                       value={apellido_2} 
                                                       placeholder="Escriba segundo apellido" 
                                                       onChange={this.cambioValor} />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="sexo">Sexo *</label>
                                                <select name="sexo"
                                                    id="sexo"
                                                    className={`form-select form-select-sm ${this.tieneError("sexo") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    value={sexo}>
                                                    <option value="">Seleccione el Género</option>
                                                    <option value="M">Masculino</option>
                                                    <option value="F">Femenino</option>
                                                    <option value="O">Otro</option>
                                                </select>
                                                {this.tieneError("sexo") && 
                                                    <small className="invalid-feedback">{errores.sexo}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="estado">Estado *</label>
                                                <select name="estado"
                                                    id="estado"
                                                    className={`form-select form-select-sm ${this.tieneError("estado") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    value={estado}>
                                                    <option value="">Seleccione el Estado</option>
                                                    <option value="0">Activo</option>
                                                    <option value="1">Inactivo</option>
                                                </select>
                                                {this.tieneError("estado") && 
                                                    <small className="invalid-feedback">{errores.estado}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="rol">Rol *</label>
                                                <select name="rol"
                                                    id="rol"
                                                    className={`form-select form-select-sm ${this.tieneError("rol") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    value={rol}>
                                                    <option value="">Seleccione el Rol</option>
                                                    {rolesFiltrados.map((itemRoles) => (
                                                        <option key={itemRoles.id} value={itemRoles.id}>{itemRoles.nombre}</option>
                                                    ))}
                                                </select>
                                                {this.tieneError("rol") && 
                                                    <small className="invalid-feedback">{errores.rol}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="cargo">Cargo *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("cargo") ? "is-invalid" : ""}`} 
                                                       type="text" 
                                                       name="cargo" 
                                                       id="cargo" 
                                                       value={cargo} 
                                                       placeholder="Cargo asignado" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="off" />
                                                {this.tieneError("cargo") && 
                                                    <small className="invalid-feedback">{errores.cargo}</small>}
                                            </div>
                                        </div>
                                        <div style={{ marginTop: 0 }} className="row g-3">
                                           <div className="col-md-6">
                                                <label htmlFor="correo_electronico">Correo Electrónico *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("correo_electronico") ? "is-invalid" : ""}`} 
                                                       type="email" 
                                                       name="correo_electronico" 
                                                       id="correo_electronico" 
                                                       value={correo_electronico} 
                                                       placeholder="ejemplo@dominio.com" 
                                                       onChange={this.cambioValor} />
                                                {this.tieneError("correo_electronico") && 
                                                    <small className="invalid-feedback">{errores.correo_electronico}</small>}
                                            </div>
                                            
                                            <div className="col-md-3">
                                                <label htmlFor="password1">Contraseña *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("password1") ? "is-invalid" : ""}`} 
                                                       type="password" 
                                                       name="password1" 
                                                       id="password1" 
                                                       value={password1} 
                                                       placeholder="CONTRASEÑA" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="new-password" />
                                                {this.tieneError("password1") && 
                                                    <small className="invalid-feedback">{errores.password1}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="password2">Confirmar *</label>
                                                <input className={`form-control form-control-sm ${this.tieneError("password2") ? "is-invalid" : ""}`} 
                                                       type="password" 
                                                       name="password2" 
                                                       id="password2" 
                                                       value={password2} 
                                                       placeholder="CONFIRMAR CONTRASEÑA" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="new-password" />
                                                {this.tieneError("password2") && 
                                                    <small className="invalid-feedback">{errores.password2}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className='row'>
                                    <div className='col-xl-12 text-center'>
                                        <div className="btn-group" role="group">
                                            <button type="submit" className="btn btn-success btn-sm">
                                                <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Usuario
                                            </button>&nbsp;&nbsp;
                                            <button type="button" className="btn btn-danger btn-sm" onClick={onClose}>
                                                <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Modal de Editar Usuario
class ModalEditar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: {
                id: '',
                tipo_documento: '',
                identificacion: '',
                nombre: '',
                nombre_2: '',
                apellido: '',
                apellido_2: '',
                sexo: '',
                bloqueado: '',
                cargo: '',
                email: '',
                id_rol: '',
                password1: '',
                password2: '',
                rol_nombre: ''
            },
            roles: [],
            errores: {},
            touched: {},
            rol_actual: localStorage.getItem('rol'),
            esUsuarioProtegido: false
        }
    }
    
    cambioValor = (e) => {
        const { name, value } = e.target;
        this.setState({
            usuario: {
                ...this.state.usuario,
                [name]: value
            },
            touched: {
                ...this.state.touched,
                [name]: true
            }
        }, () => {
            // Validar campo solo si es obligatorio
            if (this.esCampoObligatorio(name)) {
                this.validarCampo(name, value);
            }
        });
    };

    esCampoObligatorio = (campo) => {
        const camposObligatorios = [
            'tipo_documento', 'identificacion', 'nombre', 
            'sexo', 'bloqueado', 'cargo', 'email', 'id_rol'
        ];
        return camposObligatorios.includes(campo);
    }

    validarCampo = (nombreCampo, valor) => {
        const errores = { ...this.state.errores };
        
        switch(nombreCampo) {
            case 'tipo_documento':
                if (!valor) errores.tipo_documento = 'Seleccione el Tipo de Documento';
                else delete errores.tipo_documento;
                break;
            case 'identificacion':
                if (!valor.trim()) errores.identificacion = 'Digite la Identificación';
                else if (!validator.isNumeric(valor) && valor.trim().length < 5) 
                    errores.identificacion = 'La identificación debe ser numérica y tener al menos 5 dígitos';
                else delete errores.identificacion;
                break;
            case 'nombre':
                if (!valor.trim()) errores.nombre = 'Digite el Nombre';
                else if (!validator.isAlpha(valor.replace(/\s/g, ''), 'es-ES')) 
                    errores.nombre = 'El nombre solo debe contener letras';
                else delete errores.nombre;
                break;
            case 'apellido':
                if (valor && valor.trim() && !validator.isAlpha(valor.replace(/\s/g, ''), 'es-ES')) {
                    errores.apellido = 'El apellido solo debe contener letras';
                } else {
                    delete errores.apellido;
                }
                break;
            case 'sexo':
                if (!valor) errores.sexo = 'Seleccione el Género';
                else delete errores.sexo;
                break;
            case 'bloqueado':
                if (valor === '') errores.bloqueado = 'Seleccione el Estado';
                else delete errores.bloqueado;
                break;
            case 'cargo':
                if (!valor.trim()) errores.cargo = 'Digite el Cargo';
                else delete errores.cargo;
                break;
            case 'email':
                if (!valor.trim()) errores.email = 'Digite el Correo Electrónico';
                else if (!validator.isEmail(valor)) 
                    errores.email = 'Digite un email válido';
                else delete errores.email;
                break;
            case 'id_rol':
                if (!valor) errores.id_rol = 'Seleccione el Rol';
                else delete errores.id_rol;
                break;
            case 'password1':
                if (valor && valor !== '') {
                    const validacionPass = this.validarPassword(valor);
                    if (validacionPass !== 0) {
                        errores.password1 = 'La contraseña debe contener mínimo 8 caracteres, 1 letra minúscula, 1 mayúscula, 1 número y 1 carácter especial';
                    } else {
                        delete errores.password1;
                    }
                } else {
                    delete errores.password1;
                }
                // Validar password2 si tiene valor
                if (this.state.usuario.password2) {
                    this.validarCampo('password2', this.state.usuario.password2);
                }
                break;
            case 'password2':
                if (this.state.usuario.password1 && this.state.usuario.password1 !== '') {
                    if (!valor) {
                        errores.password2 = 'Confirme la Contraseña';
                    } else if (valor !== this.state.usuario.password1) {
                        errores.password2 = 'Las contraseñas no coinciden';
                    } else {
                        delete errores.password2;
                    }
                } else {
                    delete errores.password2;
                }
                break;
            default:
                break;
        }
        
        this.setState({ errores });
    }

    validarPassword(pass) {
        if (validator.isStrongPassword(pass, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
        })) {
            return 0;
        } else {
            return 1;
        }
    }

    validarTodosLosCampos = () => {
        const camposObligatorios = [
            'tipo_documento', 'identificacion', 'nombre', 
            'sexo', 'bloqueado', 'cargo', 'email', 'id_rol'
        ];
        
        // Marcar todos los campos obligatorios como tocados
        const touched = { ...this.state.touched };
        camposObligatorios.forEach(campo => {
            touched[campo] = true;
        });
        
        // Validar cada campo obligatorio
        camposObligatorios.forEach(campo => {
            this.validarCampo(campo, this.state.usuario[campo]);
        });
        
        // Validar contraseñas si se están cambiando
        if (this.state.usuario.password1 && this.state.usuario.password1 !== '') {
            this.validarCampo('password1', this.state.usuario.password1);
            this.validarCampo('password2', this.state.usuario.password2);
        }
        
        this.setState({ touched });
        
        // Verificar si hay errores
        return Object.keys(this.state.errores).length === 0;
    }

    enviarDatos = async (e) => {
        e.preventDefault();
        
        // Verificar si el usuario es protegido (rol id = 1)
        if (this.state.esUsuarioProtegido) {
            const rolActualNum = parseInt(this.state.rol_actual);
            if (rolActualNum !== 1) {
                Swal.fire({
                    icon: 'error',
                    title: 'Acceso Denegado',
                    text: 'No tiene permisos para editar usuarios con rol de Administrador',
                    timer: 3000
                });
                return;
            }
        }
        
        // Validar todos los campos
        if (!this.validarTodosLosCampos()) {
            Swal.fire({
                icon: 'error',
                title: 'Error de validación',
                text: 'Por favor, complete correctamente todos los campos obligatorios',
                timer: 3000
            });
            return;
        }

        const { usuario } = this.state;

        let formData = new FormData();
        Object.keys(usuario).forEach(key => {
            if (key !== 'password1' && key !== 'password2' && key !== 'rol_nombre') {
                formData.append(key, key === 'nombre' || key === 'nombre_2' || key === 'apellido' || key === 'apellido_2' || key === 'cargo' 
                    ? usuario[key].trim() 
                    : usuario[key]);
            }
        });
        
        if (usuario.password1 && usuario.password1 !== '') {
            formData.append('password1', usuario.password1);
            formData.append('password2', usuario.password2);
        }

        try {
            const datosRespuesta = await authAxios.post("usuario/editar", formData);
            await Swal.fire({
                icon: 'success',
                title: 'Usuario!',
                text: datosRespuesta.data.msj,
                timer: 2000
            });
            this.props.onClose();
            this.props.onUserUpdated();
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: error.response?.data?.msj || 'Ocurrió un error al actualizar el usuario'
            });
        }
    }

    componentDidMount() {
        Swal.showLoading();
        authAxios.get("usuario/roles")
            .then((datosRespuesta) => {
                this.setState({ roles: datosRespuesta.data.data });
                Swal.close();
            })
            .catch(error => {
                console.error("Error cargando roles:", error);
                Swal.close();
            });

        if (this.props.userId) {
            this.cargarUsuario(this.props.userId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.userId && this.props.userId !== prevProps.userId) {
            this.cargarUsuario(this.props.userId);
        }
    }

    cargarUsuario = async (userId) => {
    try {
        Swal.showLoading();
        const datosRespuesta = await authAxios.get("usuario/ver/" + userId);
        const usuarioData = datosRespuesta.data.data;
        
        // Verificar si el usuario tiene rol id = 1
        const esProtegido = parseInt(usuarioData.id_rol) === 1;
        
        // Asegurarse de que todos los campos tengan valores por defecto
        const usuarioLimpio = {
            id: usuarioData.id || '',
            tipo_documento: usuarioData.tipo_documento || '',
            identificacion: usuarioData.identificacion || '',
            nombre: usuarioData.nombre || '',
            nombre_2: usuarioData.nombre_2 || '',
            apellido: usuarioData.apellido || '',
            apellido_2: usuarioData.apellido_2 || '',
            sexo: usuarioData.sexo || '',
            bloqueado: usuarioData.bloqueado?.toString() || '',
            cargo: usuarioData.cargo || '',
            email: usuarioData.email || '',
            id_rol: usuarioData.id_rol || '',
            rol_nombre: usuarioData.rol_nombre || '',
            password1: '',
            password2: ''
        };
        
        this.setState({ 
            usuario: usuarioLimpio,
            errores: {},
            touched: {},
            esUsuarioProtegido: esProtegido
        });
        Swal.close();
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'No se pudo cargar la información del usuario'
        });
        Swal.close();
    }
}

    // Función para filtrar roles según el rol_actual
    filtrarRolesPorRol = (roles) => {
        const { rol_actual } = this.state;
        
        // Convertir a número para comparación segura
        const rolActualNum = parseInt(rol_actual);
        
        // Si rol_actual es igual a 1, mostrar todos los roles
        if (rolActualNum === 1) {
            return roles;
        }
        
        // Si rol_actual es diferente de 1, filtrar para NO mostrar el rol con id === 1
        return roles.filter(rol => rol.id !== 1);
    }

    tieneError = (campo) => {
        return this.state.touched[campo] && this.state.errores[campo];
    }

    render() {
        const { show, onClose } = this.props;
        const { usuario, roles, errores, esUsuarioProtegido, rol_actual } = this.state;

        // Aplicar el filtro de roles según el rol_actual
        const rolesFiltrados = this.filtrarRolesPorRol(roles);
        
        // Verificar si el usuario actual puede editar este usuario
        const rolActualNum = parseInt(rol_actual);
        const puedeEditar = !esUsuarioProtegido || rolActualNum === 1;

        if (!show) return null;

        return (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">EDITAR USUARIO</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {esUsuarioProtegido && rolActualNum !== 1 && (
                                <div className="alert alert-warning" role="alert">
                                    <strong>¡Atención!</strong> Este usuario tiene rol de Administrador y no puede ser modificado.
                                </div>
                            )}
                            <form onSubmit={this.enviarDatos} id="form" autoComplete="off" noValidate>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className='row g-3'>
                                            <div className="col-md-3">
                                                <input type="hidden" name="id" value={usuario.id || ''} />
                                                <label htmlFor="tipo_documento">T. Identificación *</label>
                                                <select name="tipo_documento"
                                                    id="tipo_documento"
                                                    value={usuario.tipo_documento || ''}
                                                    className={`form-select form-select-sm ${this.tieneError("tipo_documento") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    disabled={esUsuarioProtegido && rolActualNum !== 1}>
                                                    <option value="">Seleccione el T.I.</option>
                                                    <option value="CC">C.C.</option>
                                                    <option value="CE">C.E.</option>
                                                    <option value="NIT">NIT</option>
                                                    <option value="TI">TI</option>
                                                </select>
                                                {this.tieneError("tipo_documento") && 
                                                    <small className="invalid-feedback">{errores.tipo_documento}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="identificacion">Identificación *</label>
                                                <input type="text" 
                                                       name="identificacion" 
                                                       id="identificacion" 
                                                       value={usuario.identificacion || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("identificacion") ? "is-invalid" : ""}`} 
                                                       maxLength={20} 
                                                       placeholder="IDENTIFICACIÓN" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("identificacion") && 
                                                    <small className="invalid-feedback">{errores.identificacion}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="nombre">Nombre *</label>
                                                <input type="text" 
                                                       name="nombre" 
                                                       id="nombre" 
                                                       value={usuario.nombre || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("nombre") ? "is-invalid" : ""}`} 
                                                       placeholder="NOMBRE" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("nombre") && 
                                                    <small className="invalid-feedback">{errores.nombre}</small>}
                                            </div>
                                             <div className="col-md-3">
                                                <label htmlFor="nombre_2">Segundo Nombre</label>
                                                <input type="text" 
                                                       name="nombre_2" 
                                                       id="nombre_2" 
                                                       value={usuario.nombre_2 || ''}
                                                       className="form-control form-control-sm" 
                                                       placeholder="SEGUNDO NOMBRE" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                            </div>
                                             <div className="col-md-3">
                                                <label htmlFor="apellido">Apellido</label>
                                                <input type="text" 
                                                       name="apellido" 
                                                       id="apellido" 
                                                       value={usuario.apellido || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("apellido") ? "is-invalid" : ""}`} 
                                                       placeholder="APELLIDO" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("apellido") && 
                                                    <small className="invalid-feedback">{errores.apellido}</small>}
                                            </div>
                                             <div className="col-md-3">
                                                <label htmlFor="apellido_2">Segundo Apellido</label>
                                                <input type="text" 
                                                       name="apellido_2" 
                                                       id="apellido_2" 
                                                       value={usuario.apellido_2 || ''}
                                                       className="form-control form-control-sm" 
                                                       placeholder="SEGUNDO APELLIDO" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="sexo">Género *</label>
                                                <select name="sexo"
                                                    id="sexo"
                                                    value={usuario.sexo || ''}
                                                    className={`form-select form-select-sm ${this.tieneError("sexo") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    disabled={esUsuarioProtegido && rolActualNum !== 1}>
                                                    <option value="">Seleccione el Género</option>
                                                    <option value="M">Masculino</option>
                                                    <option value="F">Femenino</option>
                                                    <option value="O">Otro</option>
                                                </select>
                                                {this.tieneError("sexo") && 
                                                    <small className="invalid-feedback">{errores.sexo}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="bloqueado">Estado *</label>
                                                <select name="bloqueado"
                                                    id="bloqueado"
                                                    value={usuario.bloqueado || ''}
                                                    className={`form-select form-select-sm ${this.tieneError("bloqueado") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    disabled={esUsuarioProtegido && rolActualNum !== 1}>
                                                    <option value="">Seleccione el Estado</option>
                                                    <option value="0">Activo</option>
                                                    <option value="1">Inactivo</option>
                                                </select>
                                                {this.tieneError("bloqueado") && 
                                                    <small className="invalid-feedback">{errores.bloqueado}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="id_rol">Rol *</label>
                                                <select name="id_rol"
                                                    id="id_rol"
                                                    value={usuario.id_rol || ''}
                                                    className={`form-select form-select-sm ${this.tieneError("id_rol") ? "is-invalid" : ""}`}
                                                    onChange={this.cambioValor}
                                                    disabled={esUsuarioProtegido && rolActualNum !== 1}>
                                                    <option value="">Seleccione el Rol</option>
                                                    {rolesFiltrados.map((itemRoles) => (
                                                        <option key={itemRoles.id} value={itemRoles.id}>{itemRoles.nombre}</option>
                                                    ))}
                                                </select>
                                                {this.tieneError("id_rol") && 
                                                    <small className="invalid-feedback">{errores.id_rol}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="cargo">Cargo *</label>
                                                <input type="text" 
                                                       name="cargo" 
                                                       id="cargo" 
                                                       value={usuario.cargo || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("cargo") ? "is-invalid" : ""}`} 
                                                       placeholder="CARGO" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="off"
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("cargo") && 
                                                    <small className="invalid-feedback">{errores.cargo}</small>}
                                            </div>
                                        </div>
                                        <div style={{ marginTop: 0 }} className="row g-3">
                                            <div className="col-md-6">
                                                <label htmlFor="email">Correo Electrónico *</label>
                                                <input type="email" 
                                                       name="email" 
                                                       id="email" 
                                                       value={usuario.email || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("email") ? "is-invalid" : ""}`} 
                                                       placeholder="CORREO ELECTRÓNICO" 
                                                       onChange={this.cambioValor}
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("email") && 
                                                    <small className="invalid-feedback">{errores.email}</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="password1">Contraseña (Opcional)</label>
                                                <input type="password" 
                                                       name="password1" 
                                                       id="password1" 
                                                       value={usuario.password1 || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("password1") ? "is-invalid" : ""}`} 
                                                       placeholder="NUEVA CONTRASEÑA" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="new-password"
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("password1") && 
                                                    <small className="invalid-feedback">{errores.password1}</small>}
                                                {!this.tieneError("password1") && 
                                                    <small className="text-muted">Dejar en blanco para no cambiar</small>}
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="password2">Confirmar Contraseña</label>
                                                <input type="password" 
                                                       name="password2" 
                                                       id="password2" 
                                                       value={usuario.password2 || ''}
                                                       className={`form-control form-control-sm ${this.tieneError("password2") ? "is-invalid" : ""}`} 
                                                       placeholder="CONFIRMAR" 
                                                       onChange={this.cambioValor} 
                                                       autoComplete="new-password"
                                                       disabled={esUsuarioProtegido && rolActualNum !== 1}
                                                />
                                                {this.tieneError("password2") && 
                                                    <small className="invalid-feedback">{errores.password2}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className='row'>
                                    <div className='col-xl-12 text-center'>
                                        <div className="btn-group" role="group">
                                            <button type="submit" className="btn btn-primary btn-sm" disabled={esUsuarioProtegido && rolActualNum !== 1}>
                                                <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp; Editar Usuario
                                            </button>&nbsp;&nbsp;
                                            <button type="button" className="btn btn-danger btn-sm" onClick={onClose}>
                                                <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Componente Principal Listar con Modales
class Listar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            load: '',
            datosCargados: false,
            usuarios: [],
            usuariosOriginal: [],
            showCreateModal: false,
            showEditModal: false,
            selectedUserId: null,
            roles: [],
            filtros: {
                nombres: '',
                apellidos: '',
                identificacion: '',
                correo: '',
                cargo: '',
                rol: '',
                estado: '',
                sexo: '',
                tipo_documento: ''
            },
            rol_actual: localStorage.getItem('rol')
        }
    }

    borrarRegistros = async (id, id_rol, rol_nombre) => {
        // Verificar si el usuario tiene rol id = 1
        if (parseInt(id_rol) === 1) {
            const rolActualNum = parseInt(this.state.rol_actual);
            if (rolActualNum !== 1) {
                Swal.fire({
                    icon: 'error',
                    title: 'Acceso Denegado',
                    text: 'No tiene permisos para eliminar usuarios con rol de Administrador',
                    timer: 3000
                });
                return;
            }
        }

        const result = await Swal.fire({
            title: '¿Está seguro de Eliminar el Usuario?',
            text: "Esta acción no se puede revertir",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                Swal.showLoading();
                const datosRespuesta = await authAxios.get("usuario/delusuario/" + id);
                Swal.fire({
                    icon: 'success',
                    title: 'Borrado!',
                    text: datosRespuesta.data.msj,
                    timer: 2000
                });
                this.ListarUsuarios(1);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo eliminar el usuario'
                });
            }
        }
    };

    handleFiltroChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            filtros: {
                ...this.state.filtros,
                [name]: value
            }
        }, () => {
            this.aplicarFiltros();
        });
    };

    aplicarFiltros = () => {
        const { usuariosOriginal, filtros } = this.state;
        
        if (usuariosOriginal.length === 0) return;

        const usuariosFiltrados = usuariosOriginal.filter(usuario => {
            const nombresCompletos = `${usuario.nombre || ''} ${usuario.nombre_2 || ''}`.toUpperCase();
            const apellidosCompletos = `${usuario.apellido || ''} ${usuario.apellido_2 || ''}`.toUpperCase();
            const identificacion = (usuario.identificacion || '').toUpperCase();
            const correo = (usuario.email || '').toUpperCase();
            const cargo = (usuario.cargo || '').toUpperCase();
            const rol = (usuario.rol_nombre || '').toUpperCase();
            const estado = usuario.bloqueado !== undefined ? usuario.bloqueado.toString() : '';
            const sexo = (usuario.sexo || '').toUpperCase();
            const tipo_documento = (usuario.tipo_documento || '').toUpperCase();

            return (
                (filtros.nombres === '' || nombresCompletos.includes(filtros.nombres.toUpperCase())) &&
                (filtros.apellidos === '' || apellidosCompletos.includes(filtros.apellidos.toUpperCase())) &&
                (filtros.identificacion === '' || identificacion.includes(filtros.identificacion.toUpperCase())) &&
                (filtros.correo === '' || correo.includes(filtros.correo.toUpperCase())) &&
                (filtros.cargo === '' || cargo.includes(filtros.cargo.toUpperCase())) &&
                (filtros.rol === '' || rol.includes(filtros.rol.toUpperCase())) &&
                (filtros.estado === '' || estado === filtros.estado) &&
                (filtros.sexo === '' || sexo.includes(filtros.sexo.toUpperCase())) &&
                (filtros.tipo_documento === '' || tipo_documento.includes(filtros.tipo_documento.toUpperCase()))
            );
        });

        this.setState({ usuarios: usuariosFiltrados });
    };

    limpiarFiltros = () => {
        this.setState({
            filtros: {
                nombres: '',
                apellidos: '',
                identificacion: '',
                correo: '',
                cargo: '',
                rol: '',
                estado: '',
                sexo: '',
                tipo_documento: ''
            }
        }, () => {
            this.setState({ usuarios: this.state.usuariosOriginal });
        });
    };

    openCreateModal = () => {
        this.setState({ showCreateModal: true });
    }

    closeCreateModal = () => {
        this.setState({ showCreateModal: false });
    }

    openEditModal = (userId) => {
        this.setState({ 
            showEditModal: true, 
            selectedUserId: userId 
        });
    }
    
    closeEditModal = () => {
        this.setState({ 
            showEditModal: false, 
            selectedUserId: null 
        });
    }

    handleUserCreated = () => {
        this.ListarUsuarios(1);
        this.closeCreateModal();
    }

    handleUserUpdated = () => {
        this.ListarUsuarios(1);
        this.closeEditModal();
    }

    ListarUsuarios = async (page) => {
        try {
            Swal.showLoading();
            let bname = document.getElementById('bnombre')?.value || '';
            if (bname === '') {
                bname = 0;
            }
            const datosRespuesta = await authAxios.get("usuario/index/" + bname + "?page=" + page);
            Swal.close();
            this.setState({ 
                datosCargados: true, 
                load: '', 
                usuarios: datosRespuesta.data.data.data, 
                usuariosOriginal: datosRespuesta.data.data.data,
                pagina: datosRespuesta.data.data.total, 
                ultimo: datosRespuesta.data.data.last_page, 
                actual: datosRespuesta.data.data.current_page 
            });
            this.limpiarFiltros();
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo cargar la lista de usuarios'
            });
        }
    }

    componentDidMount() {
        authAxios.get("usuario/roles")
            .then((datosRespuesta) => {
                this.setState({ roles: datosRespuesta.data.data });
            })
            .catch(error => {
                console.error("Error cargando roles:", error);
            });
        this.ListarUsuarios(1);
    }

    render() {
        const { load, usuarios, pagina, ultimo, actual, showCreateModal, showEditModal, selectedUserId, filtros ,roles, rol_actual } = this.state;
        
        const rolActualNum = parseInt(rol_actual);

        return (
            <div className="content">
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-body">
                                    <button 
                                        className="btn btn-success btn-sm" 
                                        onClick={this.openCreateModal}
                                    >
                                        <FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Usuario
                                    </button>
                                    <h4>Lista Usuarios</h4>
                                    <hr />
                                    
                                    {/* Filtro general */}
                                    <div className="row mb-3">
                                        <div className="col-xl-3">
                                            <input 
                                                type="text" 
                                                id="bnombre" 
                                                name="bnombre" 
                                                placeholder="BUSCAR POR NOMBRE" 
                                                className="form-control form-control-sm" 
                                            />
                                        </div>
                                        <div className="col-xl-3">
                                            <button 
                                                id="bt" 
                                                name="bt" 
                                                className="btn btn-primary btn-sm" 
                                                onClick={() => this.ListarUsuarios(1)}
                                            >
                                                <FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar
                                            </button>
                                            &nbsp;
                                            <button 
                                                className="btn btn-secondary btn-sm" 
                                                onClick={this.limpiarFiltros}
                                            >
                                                Limpiar Filtros
                                            </button>
                                        </div>
                                    </div>

                                    {/* Filtros por columna */}
                                    <div className="row mb-2">
                                        <div className="col-md-3">
                                            <label className="form-label small">Filtrar Nombres</label>
                                            <input
                                                type="text"
                                                name="nombres"
                                                value={filtros.nombres}
                                                onChange={this.handleFiltroChange}
                                                placeholder="Filtrar por nombres..."
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small">Filtrar Apellidos</label>
                                            <input
                                                type="text"
                                                name="apellidos"
                                                value={filtros.apellidos}
                                                onChange={this.handleFiltroChange}
                                                placeholder="Filtrar por apellidos..."
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small">Filtrar Tipo Doc</label>
                                            <select
                                                name="tipo_documento"
                                                value={filtros.tipo_documento}
                                                onChange={this.handleFiltroChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">Todos</option>
                                                <option value="CC">CC</option>
                                                <option value="CE">CE</option>
                                                <option value="NIT">NIT</option>
                                                <option value="TI">TI</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small">Filtrar Identificación</label>
                                            <input
                                                type="text"
                                                name="identificacion"
                                                value={filtros.identificacion}
                                                onChange={this.handleFiltroChange}
                                                placeholder="Filtrar por ID..."
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small">Filtrar Estado</label>
                                            <select
                                                name="estado"
                                                value={filtros.estado}
                                                onChange={this.handleFiltroChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">Todos</option>
                                                <option value="0">Activo</option>
                                                <option value="1">Inactivo</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small">Filtrar Género</label>
                                            <select
                                                name="sexo"
                                                value={filtros.sexo}
                                                onChange={this.handleFiltroChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">Todos</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Femenino</option>
                                                <option value="O">Otro</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label className="form-label small">Filtrar Correo</label>
                                            <input
                                                type="text"
                                                name="correo"
                                                value={filtros.correo}
                                                onChange={this.handleFiltroChange}
                                                placeholder="Filtrar por correo..."
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label small">Filtrar Cargo</label>
                                            <input
                                                type="text"
                                                name="cargo"
                                                value={filtros.cargo}
                                                onChange={this.handleFiltroChange}
                                                placeholder="Filtrar por cargo..."
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label small">Filtrar Rol</label>
                                            <select 
                                                name="rol"
                                                className="form-select form-select-sm"
                                                onChange={this.handleFiltroChange}
                                                value={filtros.rol}>
                                                <option value="">Todos</option>
                                                {roles.map((itemRoles) => (
                                                    <option key={itemRoles.id} value={itemRoles.nombre}>{itemRoles.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <br />
                                    <div className="row table-responsive">
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">DOC</th>
                                                    <th className="align-middle">IDENTIFICACIÓN</th>
                                                    <th className="align-middle">NOMBRES</th>
                                                    <th className="align-middle">APELLIDOS</th>
                                                    <th className="align-middle">Género</th>
                                                    <th className="align-middle">CORREO ELECTRÓNICO</th>
                                                    <th className="align-middle">CARGO</th>
                                                    <th className="align-middle">ROL</th>
                                                    <th className="align-middle">ESTADO</th>
                                                    <th className="align-middle">OPCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load}
                                                {usuarios.map((itemUsuarios) => (
                                                    <tr key={itemUsuarios.id}>
                                                        <td>{itemUsuarios.tipo_documento}</td>
                                                        <td>{itemUsuarios.identificacion}</td>
                                                        <td>{itemUsuarios.nombre} {itemUsuarios.nombre_2}</td>
                                                        <td>{itemUsuarios.apellido} {itemUsuarios.apellido_2}</td>
                                                        <td>
                                                            {itemUsuarios.sexo === 'M' && 'Masculino'}
                                                            {itemUsuarios.sexo === 'F' && 'Femenino'}
                                                            {itemUsuarios.sexo === 'O' && 'Otro'}
                                                            {!itemUsuarios.sexo && 'No especificado'}
                                                        </td>
                                                        <td>{itemUsuarios.email}</td>
                                                        <td>{itemUsuarios.cargo}</td>
                                                        <td>
                                                            {itemUsuarios.rol_nombre}
                                                            {parseInt(itemUsuarios.id_rol) === 1 && (
                                                                <span className="badge bg-warning ms-1" style={{ fontSize: '10px' }}>Protegido</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {itemUsuarios.bloqueado === 1 ? (
                                                                <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">INACTIVO</span>
                                                            ) : (
                                                                <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">ACTIVO</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" role="group">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-xs"
                                                                    onClick={() => this.openEditModal(itemUsuarios.id)}
                                                                    disabled={parseInt(itemUsuarios.id_rol) === 1 && rolActualNum !== 1}
                                                                    title={parseInt(itemUsuarios.id_rol) === 1 && rolActualNum !== 1 ? "No puedes editar un Administrador" : "Editar usuario"}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-xs"
                                                                    onClick={() => this.borrarRegistros(itemUsuarios.id, itemUsuarios.id_rol, itemUsuarios.rol_nombre)}
                                                                    disabled={parseInt(itemUsuarios.id_rol) === 1 && rolActualNum !== 1}
                                                                    title={parseInt(itemUsuarios.id_rol) === 1 && rolActualNum !== 1 ? "No puedes eliminar un Administrador" : "Eliminar usuario"}
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            <li className="page-item">
                                                <button className="page-link" onClick={() => this.ListarUsuarios(1)}>
                                                    {"<<"}
                                                </button>
                                            </li>
                                            <li className="page-item">
                                                <button className="page-link" onClick={() => this.ListarUsuarios(actual - 1)} disabled={actual <= 1}>
                                                    {"<"}
                                                </button>
                                            </li>
                                            <li className="page-item active">
                                                <span className="page-link">{actual}</span>
                                            </li>
                                            <li className="page-item">
                                                <button className="page-link" onClick={() => this.ListarUsuarios(actual + 1)} disabled={actual >= ultimo}>
                                                    {">"}
                                                </button>
                                            </li>
                                            <li className="page-item">
                                                <button className="page-link" onClick={() => this.ListarUsuarios(ultimo)}>
                                                    {">>"}
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                <div className="card-footer text-muted">
                                    <b>Página</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span> | <b>Mostrando:</b> <span className="badge bg-info">{usuarios.length}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modales */}
                <ModalCrear 
                    show={showCreateModal}
                    onClose={this.closeCreateModal}
                    onUserCreated={this.handleUserCreated}
                />
                
                <ModalEditar 
                    show={showEditModal}
                    onClose={this.closeEditModal}
                    userId={selectedUserId}
                    onUserUpdated={this.handleUserUpdated}
                />
            </div>
        );
    }
}

export default Listar;